import { createSelector } from 'reselect';
import { feedSelector } from '../transitionRouter/transitionRouter.selectors';

export const bookmakersInfoSelector = ({ bookmakersInfo }) => bookmakersInfo;

export const selectedBookmakerSelector = createSelector(
    bookmakersInfoSelector,
    ({ selectedBookmaker }) => selectedBookmaker,
);

export const selectedBetSelector = createSelector(
    bookmakersInfoSelector,
    ({ selectedBets }) => selectedBets,
);

export const betBookmakerSelector = createSelector(
    selectedBetSelector,
    selectedBets => (selectedBets.length && selectedBets[0].feed) || null,
);

export const usernameSelector = createSelector(
    [bookmakersInfoSelector, feedSelector],
    (bookmakersInfo, feed) => (
        bookmakersInfo[feed] && bookmakersInfo[feed].username
            ? bookmakersInfo[feed].username
            : ''
    ),
);




// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/bookmakersInfo.selectors.js